module.exports = __webpack_public_path__ + "img/arrow.383a81fc.svg";